import { cn } from '@/lib/utils';

export function MobileFooterButton({
  isActive = false,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { isActive?: boolean }) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        isActive
          ? 'flex-1 rounded border-2 border-sky-600 bg-sky-600 p-2 text-white shadow-sm transition-colors hover:bg-sky-700 focus:border-sky-500 focus:outline-sky-500'
          : 'flex-1 rounded border-2 border-sky-500 bg-sky-500 p-2 text-white transition-colors hover:bg-sky-600 focus:border-sky-400 focus:outline-sky-400 active:bg-sky-400',
        className,
      )}
    />
  );
}
